export const RUN_BASE_PATH = '/:entityName/:projectName/:tab(runs)/:runName';

export const FULL_SCREEN_RUNS_PANEL_PATH =
  '/:entityName/:projectName/:tab(runs)/:runName/panel/:panelId';
export const FULL_SCREEN_RUNS_WORKSPACE_PANEL_PATH =
  '/:entityName/:projectName/:tab(runs)/:runName/:runTab(workspace)/panel/:panelId';
export const EMBEDDED_RUNS_PANEL_PATH =
  '/:entityName/:projectName/:tab(runs)/:runName/embed/panel/:panelId';

export const RUNS_TAB_PATH =
  '/:entityName/:projectName/:tab(runs)/:runName/:runTab';
export const RUN_WORKSPACE_PATH =
  '/:entityName/:projectName/:tab(runs)/:runName/:runTab(workspace)';
export const RUN_FILES_PATH =
  '/:entityName/:projectName/:tab(runs)/:runName/:runTab(files)/:filePath*';
export const RUN_CODE_FILES_PATH =
  '/:entityName/:projectName/:tab(runs)/:runName/:runTab(code)/:filePath*';

export const RUN_WORKSPACE_PATHS = [
  RUN_BASE_PATH,
  RUN_WORKSPACE_PATH,
  FULL_SCREEN_RUNS_PANEL_PATH,
  FULL_SCREEN_RUNS_WORKSPACE_PANEL_PATH,
  EMBEDDED_RUNS_PANEL_PATH,
];

export const RUN_PATHS = [
  ...RUN_WORKSPACE_PATHS,
  RUN_FILES_PATH,
  RUN_CODE_FILES_PATH,
  RUNS_TAB_PATH,
];
